import { createFileRoute, redirect } from "@tanstack/react-router";
import { OrgPageLayout, OrgPageTitle } from "~/components";
import { SupportToolsLayout } from "~/modules/SupportTools/SupportToolsLayout";

const isSupportToolsEnabled = import.meta.env.VITE_SUPPORT_TOOLS_ENABLED === "true";

export const Route = createFileRoute("/_protected/(org)/_org-layout/orgs/$orgId/support-tools")({
  beforeLoad: ({ params }) => {
    if (!isSupportToolsEnabled) {
      throw redirect({ to: "/orgs/$orgId", params: { orgId: params.orgId } });
    }
  },
  component: () => (
    <OrgPageLayout title={<OrgPageTitle>Support tools</OrgPageTitle>}>
      <SupportToolsLayout showHeader={false} isOrgContext />
    </OrgPageLayout>
  ),
});
